<div class="justify-content-center my-auto">
    <ngx-loading [show]="isLoading"
      [config]="{ fullScreenBackdrop: true, backdropBackgroundColour: 'rgba(255,255,255,0.3)' }">
    </ngx-loading>
    <!-- <ngx-loading [show]="isLoading"
    [config]="{ fullScreenBackdrop: true, backdropBackgroundColour: 'rgba(255,255,255,0.3)' }">
    </ngx-loading> -->
  </div>
